import React from 'react'
import './App.css';

const ContactScreen = () => {
    const handleSubmit = (e) => {
    e.preventDefault();
    
    const name = e.target.name.value;
    const email = e.target.email.value;
    const message = e.target.message.value;
    
    const subject = `Contact Form Message from ${name}`;
    const body = `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`;
    
    const mailtoLink = `mailto:info.gemmure@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    window.location.href = mailtoLink;
  };
  return (
     <div className="content-screen">
      <h1>Contact Us</h1>
      <div className="content">
        <div className="contact-info">
          <h2>Get in Touch</h2>
          <p>We'd love to hear from you! Whether you have a question, feedback, or need support, feel free to reach out.</p>
                    <div className="contact-form">
            <h3>Send us a Message</h3>
            <form onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Your Name" className="form-input" required />
              <input type="email" name="email" placeholder="Your Email" className="form-input" required />
              <textarea name="message" placeholder="Your Message" className="form-textarea" rows="5" required></textarea>
              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactScreen

